export type MaintenanceMode = {
  isMaintenanceMode: boolean;
  setMaintenanceMode: (value: boolean) => void;
  scheduleRefresh: () => void;
};

export const defaultMaintenanceMode: MaintenanceMode = {
  isMaintenanceMode: false,
  setMaintenanceMode: () => {
    return;
  },
  scheduleRefresh: () => {
    return;
  },
};
